import { z } from 'zod';

export const requestTicketSchema = z.object({
  id: z.number(),
  name: z.string(),
  status: z.enum(['open', 'in_progress', 'closed']),
  createdAt: z.string(),
  description: z.string().nullable(),
  assignee: z.object({ id: z.number(), name: z.string() }).nullable(),
});

export type RequestTicket = z.infer<typeof requestTicketSchema>;
